import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';    
import {AuthenticationService}from './../../service/auth/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {
  public isCollapsed = false;
  loggedIn = false;
  Year:any;
  url:string;
  active:boolean;
  constructor(private auth:AuthenticationService,
              private router:Router,
              private readonly location: Location
            
            ) { 
			    this.auth.currentUser.subscribe((results) => this.isLoggedIn(results));
          this.router.events.subscribe(
            (event: any) => {
              if (event instanceof NavigationEnd) {
                this.url= this.router.url;
                if(this.router.url=='/'){
                  this.active=true;
                }else{
                  this.active=false;
                }
              }
            }
          );


			}

  ngOnInit(): void {
     this.Year=new Date().getFullYear();
  }

  isLoggedIn(results){
  	if(results){
  		this.loggedIn = true;	
  	}else{
  		this.loggedIn = false;
  	}
  }

  logout(){
    this.auth.logout().subscribe((res:any)=>{
        this.router.navigate(['/']);
    });
  }

}
